import React from 'react'

import styles from '@Blocks/ActiveCampaignBlock/styles.module.scss'
import { RTEContent } from '@Components/RTEContent'
import Status from '@Components/Status'
import { ActiveCampaignBlock as ActiveCampaignBlockData } from '@Generated/graphql'
import { convertRTEToHTML } from '@Globals/CMS/FieldHelpers'

const ActiveCampaignBlock = ({
  activeCampaignBlock,
  id,
}: {
  activeCampaignBlock: ActiveCampaignBlockData
  id: string
}) => {
  const TitleElement = (activeCampaignBlock?.common?.titleElement || 'p') as keyof React.JSX.IntrinsicElements
  const description = convertRTEToHTML(activeCampaignBlock?.description)

  return (
    <div className={styles.activeCampaign} id={id}>
      {Boolean(activeCampaignBlock?.common?.title) && (
        <div className={styles.title}>
          {activeCampaignBlock.common?.status && activeCampaignBlock.common.status !== 'none' && (
            <Status className={styles.status} color={activeCampaignBlock.common.status} />
          )}
          <TitleElement>{activeCampaignBlock?.common?.title}</TitleElement>
        </div>
      )}
      <div className={styles.content}>
        <p
          className={styles.highlightText}
          style={{
            backgroundColor: activeCampaignBlock?.appearance?.backgroundColor || undefined,
            color: activeCampaignBlock?.appearance?.textColor || undefined,
            fontFamily: `var(--font-${activeCampaignBlock?.appearance?.font || 'gotham'})`,
          }}
        >
          {activeCampaignBlock.highlightText}
        </p>
        <div className={styles.description}>
          <RTEContent html={description} />
        </div>
      </div>
    </div>
  )
}

export default ActiveCampaignBlock
